import React from 'react'
import MainHeadToAppend from './MainHeadToAppend'

function HeaderPayment() {
  return (
    <div className="MainTopButtonWrapper TopCornerButtonContainerScrolled">

    <MainHeadToAppend/>

            <div className="TopMenuPanel TopMenuPanelBlueGrad">
                <div className="TopMenuSectionWrapper TopNonIndexSearchSection">
                    <div className="ProgressStepMainContainer">
                        <div className="PaymentTopLineAndTextContainer" id="CurrentPaymentStep1">
                            <div className="ProgressStepTextContainer">
                                <div className="ProgressStepNumberContainer">
                                    <p className="InterBoldTextFont BasicInputTextTop">1</p>
                                </div>
                                <p className="InterBoldTextFont BasicInputTextTop StepTextP" id="StepTopText1">Booking Details</p>
                            </div>
                        </div>
                        <div className="PaymentTopLineAndTextContainer" id="CurrentPaymentStep2">
                            <div className="ProgressBarTopContainer">
                                <div className="ProgressBarLine">
                                    <div className="ProgressBarTopDotted" />
                                    <div className="ProgressBarWhiteBG" />
                                    <div className="ProgressBarYellow" />
                                </div>
                            </div>
                            <div className="ProgressStepTextContainer">
                                <div className="ProgressStepNumberContainer">
                                    <p className="InterBoldTextFont BasicInputTextTop">2</p>
                                </div>
                                <p className="InterBoldTextFont BasicInputTextTop StepTextP" id="StepTopText2">Payment Option</p>
                            </div>
                        </div>
                        <div className="PaymentTopLineAndTextContainer" id="CurrentPaymentStep3">
                            <div className="ProgressBarTopContainer">
                                <div className="ProgressBarLine">
                                    <div className="ProgressBarTopDotted" />
                                    <div className="ProgressBarWhiteBG" />
                                    <div className="ProgressBarYellow" />
                                </div>
                            </div>
                            <div className="ProgressStepTextContainer">
                                <div className="ProgressStepNumberContainer">
                                    <p className="InterBoldTextFont BasicInputTextTop">3</p>
                                </div>
                                <p className="InterBoldTextFont BasicInputTextTop StepTextP" id="StepTopText3">Booking Confirmed</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default HeaderPayment